<script>
    import {getContext, onMount} from "svelte";
    import {FlatToast, ToastContainer, toasts} from "svelte-toasts";
    import PickCoordinateComponent from "./PickCoordinateComponent.svelte";
    import {navigate} from "svelte-routing";
    import Toggle from "svelte-toggle";
    import {Formly} from "svelte-formly";
    import FileManagerComponent from "../ImageManagement/FileManagerComponent.svelte";
    import Service from "../utils/Service";


    const {open} = getContext('simple-modal');

    export let model_root;
    export let application_root;
    export let mid;
    export let cid;
    export let cname;

    const service = new Service(model_root);


    let currentSelectedPointForFileInput;
    let tmpFileInput;
    let tmpSelectedFile_Blob;
    let tmpSelectedFile_Name;


    let map_items = [];
    let map_config = {
        zoom: 4
    };

    onMount(() => {
        loadMapElems().then(mapItems => {
            map_items = mapItems;
        })
        loadMapConfig().then(mapConfig => {
            map_config = mapConfig[0];
        })
    })

    const selectImage = (e, item) => {
        e.preventDefault();
        currentSelectedPointForFileInput = item;
        tmpFileInput.click();
    }

    const onImageSelected = async (e) => {
        let image = e.target.files[0];
        tmpSelectedFile_Name = image.name;
        let reader = new FileReader();
        reader.readAsArrayBuffer(image); // Lies die Datei als ArrayBuffer
        reader.onload = async e => {
            const arrayBuffer = e.target.result; // Binärdaten
            tmpSelectedFile_Blob = new Blob([arrayBuffer], {type: image.type});

            let compressedFile = await service.compressImage(tmpSelectedFile_Blob);
            let response = await service.uploadFile(-3, tmpSelectedFile_Name, compressedFile, "map_point_image")
            if (currentSelectedPointForFileInput.file_id != -3) {
                await service.removeFile(currentSelectedPointForFileInput.file_id);
            }
            currentSelectedPointForFileInput.file_id = response.file_id;
            await createMapInDB(false);
        };
    }

    const deleteImage = async (e, item) => {
        e.preventDefault();
        await service.removeFile(item.file_id);
        item.file_id = -3;
        await createMapInDB(false);
    }

    const setCoordsCallback = (index, coords) => {
        map_items[index].coordinates = coords;
    };

    function openCoordPicker(index, lat, lng) {
        open(PickCoordinateComponent, {
            index: index,
            lat: lat,
            lng: lng,
            setCoords: setCoordsCallback
        }, {
            closeButton: false,
            closeOnEsc: false,
            closeOnOuterClick: false,
            styleWindow: {
                overflow: 'hidden'
            },
            styleContent: {
                padding: '0 0',
                width: '100%',
                height: '580px'
            }
        }, {});
    }

    const loadMapConfig = () => {
        return fetch(model_root + 'shared/maps/get_map_config.php?cid=' + cid, {
            method: "GET"
        })
            .then(response => response.json())
    }

    const loadMapElems = () => {
        return fetch(model_root + 'shared/maps/get_map.php?cid=' + cid, {
            method: "GET"
        })
            .then(response => response.json())
    }

    const addMapElem = () => {
        map_items = [...map_items,
            {
                title: "",
                description: "",
                focus_elem: false,
                coordinates: "",
                lat: "51.345401",
                lng: "10.146764",
                file_id: -3,
                key: (Math.random() + 1).toString(36).substring(7)
            }
        ];
    }

    const changeFocusOfElem = (index, value) => {
        if (value === true) {
            for (let item of map_items) {
                item.focus_elem = false;
            }
        }
        map_items[index].focus_elem = value;
    }

    const removeMapElem = (index) => {
        map_items.splice(index, 1);
        map_items = map_items;
    }

    function deleteEntireMapInDB() {
        return fetch(model_root + 'admin/maps/delete_map.php?cid=' + cid, {
            method: "GET"
        })
            .then(response => response.text())
            .then(msg => {
                if (msg !== "success") {
                    toasts.error('Fehler bei Vorbereitungen zum Speichern der Karte', msg, {duration: 10000});
                }
            });
    }

    async function createMapInDB(navigateBack=true) {
        if (map_items.length < 1) {
            toasts.error('Keine Punkte', "Der Karte muss mindestens ein Punkt hinzugefügt werden.", {duration: 10000});
            return;
        }
        await deleteEntireMapInDB();
        const data = new FormData();
        data.append("map_cid", cid);
        data.append("map_zoom", map_config.zoom);

        fetch(model_root + 'admin/maps/create_map.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(async msg => {
                if (msg === "success") {
                    for (let i in map_items) {
                        try {
                            await createMapElemInTB(i);
                        } catch (e) {
                            await deleteEntireMapInDB();
                            return;
                        }
                    }
                    if (navigateBack) {
                        toasts.success('Karte erfolgreich gespeichert', 'Das Fenster schließt sich automatisch.', {duration: 3000});
                        setTimeout(() => {
                            navigate("/menu-item/" + mid, {replace: true})
                        }, 3000);
                    } else {
                        toasts.success('Karte erfolgreich gespeichert', 'Die Seite wird automatisch neu geladen...', {duration: 3000});
                        setTimeout(() => {
                            location.reload();
                        }, 3000)
                    }
                } else {
                    toasts.error('Fehler beim Speichern der Karte', msg, {duration: 10000});
                    await deleteEntireMapInDB();
                }
            });
    }

    function createMapElemInTB(index) {
        const data = new FormData();
        data.append("me_cid", cid);
        data.append("me_title", map_items[index].title);
        data.append("me_description", map_items[index].description);
        data.append("me_focus_elem", map_items[index].focus_elem);
        data.append("me_coordinates", map_items[index].coordinates);
        data.append("me_file_id", map_items[index].file_id);

        return new Promise((resolve, reject) => {
            fetch(model_root + 'admin/maps/create_map_elem.php', {
                method: "POST",
                body: data
            })
                .then(response => response.text())
                .then(msg => {
                    if (msg === "success") {
                        resolve()
                    } else {
                        toasts.error('Falscher Wert für einen Kartenpunkt', msg, {duration: 10000});
                        reject();
                    }
                });
        });

    }

</script>

<ToastContainer placement="bottom-right"
                showProgress="true"
                let:data={data}>
    <FlatToast {data}/>
</ToastContainer>

<h4 class="text-muted">MapDesigner</h4>
<h2 class="mb-4">{@html cname}</h2>

<form on:submit|preventDefault
      on:reset|preventDefault>

    <div class="row mb-3 align-items-center">
        <label for="mapZoom" class="col-sm-4 col-form-label">Map Zoom*:</label>
        <div class="col-sm d-flex align-items-center">
            <!-- Slider -->
            <input
                    id="mapZoom"
                    type="range"
                    class="form-range me-3 flex-grow-1 border-0"
                    min="10"
                    max="17"
                    step="0.5"
                    bind:value={map_config.zoom}>
            <!-- Readonly Value -->
            <input
                    type="number"
                    class="form-control text-center border-0 bg-transparent p-0"
                    style="width: 50px; font-size: 0.9rem; color: #6c757d;"
                    min="10"
                    max="17"
                    step="0.5"
                    value={map_config.zoom}
                    readonly>
        </div>
    </div>



    <hr class="mb-3">

    <div>
        {#each map_items as item, index}
            <div class="row mb-3 px-2 form-list-item">
                <div class="border rounded p-3">
                    <div class="row my-1">
                        <label class="col-sm-4 col-form-label">Point title*:</label>
                        <div class="col-sm">
                            <input type="text" class="form-control" bind:value={item.title}>
                        </div>
                    </div>
                    <div class="row my-1">
                        <label class="col-sm-4 col-form-label">Point header image:</label>
                        <div class="change_point_image_container m-3 p-2 border w-50 d-block">
                            {#if item.file_id == -3}
                                <button class="btn btn-secondary select_empty_btn mt-1" on:click={(e) => {selectImage(e, item)}}>
                                    Select image
                                </button>
                            {:else}
                                {#await service.getFilePath(item.file_id)}
                                    warte..
                                {:then src}
                                    <div class="change_btn float-end">
                                        <button class="btn btn-secondary" on:click={(e) => {selectImage(e, item)}}>
                                            Change image
                                        </button>
                                        <button class="btn btn-secondary" on:click={(e) => {deleteImage(e, item)}}>
                                            <i class="fas fa-trash"></i>
                                        </button>
                                    </div>
                                    <img src="{application_root}files/{src}" class="point_image"/>
                                {/await}
                            {/if}
                        </div>
                    </div>
                    <div class="row my-1">
                        <label class="col-sm-4 col-form-label">Point description:</label>
                        <div class="col-sm">
                            <textarea class="form-control" placeholder="optional"
                                      bind:value={item.description}></textarea>
                        </div>
                    </div>
                    <div class="row my-1">
                        <label class="col-sm-4 col-form-label">Point coordinate*:</label>
                        <div class="col-sm">
                            <input on:focus={ () => { openCoordPicker(index, item.lat, item.lng) }} type="text"
                                   class="form-control" placeholder="Click to pick a coordinate"
                                   bind:value={item.coordinates}>
                        </div>
                    </div>
                    <div class="row my-1">
                        <label class="col-sm-4 col-form-label">Set as focus-point?</label>
                        <div class="col-sm pt-2">
                            <Toggle toggled={item.focus_elem} hideLabel={true} toggledColor="#2d3e4f"
                                    on:toggle={(e) => {changeFocusOfElem(index, e.detail)}}/>
                        </div>
                    </div>
                    <hr class="my-3">
                    <div class="row my-1">
                        <div class="col">
                            <button class="btn btn-outline-secondary w-auto py-1 px-2"
                                    on:click={() => { removeMapElem(index) }}>
                                <small>
                                    <i class="far fa-trash-alt"></i> Remove point
                                </small>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        {/each}
    </div>

    <button class="btn btn-link text-dark" on:click={addMapElem}>Add point</button>

    <hr class="mb-4">

    <button class="btn btn-primary me-2" on:click={createMapInDB}>Save map</button>
    <button class="btn btn-secondary" on:click={() => {navigate("/menu-item/"+mid, {replace: true})}}>Dismiss changes
    </button>
</form>

<input style="display:none" type="file" accept=".jpg, .jpeg, .png"
       on:change={(e)=>onImageSelected(e)} bind:this={tmpFileInput}>

<style>
    .point_image {
        max-width: 250px;
    }

    .change_point_image_container {
    }
</style>
